import {inputFieldInitialState, InputFieldState} from "../../shared/helpers/InputFieldState";
import {Attachment} from "../../shared/models/Attachment";

export class JobApplication {
    public name: InputFieldState;
    public firstname: InputFieldState;
    public phone: InputFieldState;
    public email: InputFieldState;
    public experience: InputFieldState;
    public qualification: InputFieldState;
    public attentiveThrough: InputFieldState;
    public attachments: Attachment[];

    constructor(public title: string, public url: string) {
        this.name = inputFieldInitialState('', true);
        this.firstname = inputFieldInitialState('', true);
        this.phone = inputFieldInitialState('', true);
        this.email = inputFieldInitialState('', true);
        this.experience = inputFieldInitialState('', true);
        this.qualification = inputFieldInitialState('', true);
        this.attentiveThrough = inputFieldInitialState('', true);
        this.attachments = [];
    }
}
